import React from 'react';
import {
  Breadcrumbs as MUIBreadcrumbs,
  Link,
  Typography,
  SxProps,
  Theme,
} from '@mui/material';
import { getBreadcrumbs } from '../types/breadcrumbs';

type Props = {
  activePage: string;
  setActivePage: (p: string) => void;
  selectedEffortName?: string | null;
  sx?: SxProps<Theme>;
};

const Breadcrumbs: React.FC<Props> = ({
  activePage,
  setActivePage,
  selectedEffortName,
  sx,
}) => {
  const crumbs = getBreadcrumbs(activePage, selectedEffortName);
  return (
    <MUIBreadcrumbs
      separator='›'
      sx={{
        px: 2,
        py: 1,
        ...(sx as object),
      }}
    >
      {crumbs.map((c, idx) => {
        const isLast = idx === crumbs.length - 1;
        const clickable = !!c.page && !c.isDisabled && !isLast;
        const onHomePage =
          crumbs.length === 1 && crumbs[0].label === 'Homepage';
        return clickable ? (
          <Link
            underline='hover'
            component='button'
            key={`${c.label}-${idx}`}
            sx={{
              cursor: 'pointer',
              color: theme => theme.palette.neutrals.gray_light_3,
            }}
            onClick={() => setActivePage(c.page!)}
          >
            {c.label}
          </Link>
        ) : !onHomePage ? (
          <Typography
            key={`${c.label}-${idx}`}
            sx={{ color: theme => theme.palette.common.black }}
          >
            {c.label}
          </Typography>
        ) : null;
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
